import { render, staticRenderFns } from "./dashboardJournalAds.vue?vue&type=template&id=05d9c64e&scoped=true&"
import script from "./dashboardJournalAds.vue?vue&type=script&lang=js&"
export * from "./dashboardJournalAds.vue?vue&type=script&lang=js&"
import style0 from "./dashboardJournalAds.vue?vue&type=style&index=0&id=05d9c64e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d9c64e",
  null
  
)

export default component.exports